<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {};
</script>

<style>
.v-input .v-label {
  font-size: 12px;
}
.field_height.v-text-field .v-input_control .v-input_slot {
  min-height: 12px !important;
  display: flex !important;
  align-items: center !important;
}
.field_label_size.v-input .v-label {
  font-size: 12px;
}
.v-select .v-input_control .v-inputslot .v-selectslot .v-select_selections {
  padding: 0 !important;
  min-height: 0 !important;
}

.v-select-list .v-list-item {
  min-height: 0 !important;
}

.v-select-list .v-list-item .v-list-item__content {
  padding: 14px 0 !important;
}
.fontsize12px {
  font-size: 12px !important;
}
.fontsize13px {
  font-size: 13px !important;
}
.fontsize14px {
  font-size: 14px !important;
}
.fontsize15px {
  font-size: 15px !important;
}
.fontsize16px {
  font-size: 16px !important;
}
.fontsize17px {
  font-size: 17px !important;
}
.fontsize18px {
  font-size: 18px !important;
}
.fontsize19px {
  font-size: 19px !important;
}
.fontsize20px {
  font-size: 20px !important;
}
.fontsize21px {
  font-size: 21px !important;
}
.fontsize22px {
  font-size: 22px !important;
}
.fontsize23px {
  font-size: 23px !important;
}
.fontsize24px {
  font-size: 24px !important;
}
.fontsize25px {
  font-size: 25px !important;
}
.fontsize30px {
  font-size: 30px !important;
}
.fontsize31px {
  font-size: 31px !important;
}
.fontsize32px {
  font-size: 32px !important;
}
.fontsize33px {
  font-size: 33px !important;
}
.fontsize34px {
  font-size: 34px !important;
}
.fontsize35px {
  font-size: 35px !important;
}
.fontsize40px {
  font-size: 40px !important;
}

.DialogOpenFromTop {
  align-self: flex-start !important;
}
.LoginBack {
  background-color: #2e4392 !important;
}
.divcolor {
  color: #f8f9fc !important;
}
.v-application--is-ltr
  .v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > th,
.ImageRadius {
  border-radius: 50px;
}
.ImgRotate {
  transform: rotate(-20deg);
}
.SelectWidth {
  max-width: 100px !important;
  border-radius: 0px !important;
}
.PaginationBut {
  font-size: 6px !important;
}
.maxWidth {
  max-width: 350px !important;
}
.userimageicon {
  width: 150px;
}
.bottom-right {
  position: fixed;
  bottom: 20px;
  right: 20px;
  cursor: pointer;
}
.video-container {
  position: relative;
  width: 100px;
  height: 100px;
}

.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.ColWidth {
  width: 40px !important;
}
.card {
  border-radius: 5px 5px;

  backdrop-filter: blur(70px);
}

.footer {
  background: #2196f3;
}

.FontSize {
  font-size: 18px !important;
}
.FontSize121px {
  font-size: 12px !important;
}
.Cardtrans {
  background: url("@/assets/policeImage.webp");
}
.v-application .rounded-b1-x1 {
  border-bottom-right-radius: 1000px !important;
}
.v-application .rounded-b1-x1 {
  border-bottom-left-radius: 1000px !important;
}
.rounded-b1-x1 {
  background-color: #2e4392 !important;
  border-bottom-right-radius: 1000px !important;
  border-bottom-left-radius: 1000px !important;
}
.largeFontSize {
  font-size: 25px !important;
}
.ActiveClass {
  color: black !important;
}
.cardheight {
  height: 100vh !important;
}
.maxWidthTwo {
  max-width: 300px !important;
}
.cardHeight {
  height: 90vh !important;
}
.textfieldColor {
  border: 1px solid white !important;
}
.CursorPointer {
  cursor: pointer !important;
}
.v-navigation-drawer--left {
  top: 0;
  left: 0;
  right: auto;
  border-right-width: 0 !important;
}
.TableClassData th {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #4f4949 !important;
}
.TableClassData td {
  font-size: 12px !important;
  font-weight: 400 !important;
  color: black !important;
}
</style>
